module.exports = require('./helpers/bundle-url').getBundleURL('eIdJn') + "logo.c51670a8.svg";